import axios from 'axios';
const API = axios.create({ baseURL: 'https://chefdeclasse.com/api' });
export default API;
